<template>
  <div id="inviteRecord">
    <BottomBar />
    <!-- <router-link tag="i" to="/invite/reward" id="close" class="anyteachicon anyteach-back" /> -->
    <div class="navbar">
      <Switcher v-model="tab" :items="tabItems" />
      <router-link tag="span" to="/invite/reward" class="link">查看购课提成</router-link>
    </div>
    <swiper ref="mySwiper" class="swiper" @slideChange="tab = swiper.activeIndex">
      <swiper-slide>
        <Empty
          v-if="!friendList"
          :loading="friendList === undefined"
          title="暂无邀请记录"
          subtitle="请先使用链接或海报邀请好友"
          link="/courses"
          link-text="查看课程"
        />
        <div v-else>
          <h2>{{ friendList.length }} 位{{ user.identity > 1 ? "好友" : "客戶" }}</h2>
          <div v-for="friend in friendList" :key="friend.user_id" class="item">
            <div class="avatar" :style="$bgd(friend.gravatar)" />
            <div class="content">
              <h3>{{ friend.name }}</h3>
              <p>{{ $moment(friend.invite_time).format("YYYY-MM-DD HH:mm") }}</p>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <Empty
          v-if="!recordList"
          :loading="recordList === undefined"
          title="暂无购课提成"
          subtitle="请先邀请好友购买课程"
          link="/courses"
          link-text="查看课程"
        />
        <div v-else>
          <h2>{{ recordList.length }} 次邀请购课</h2>
          <Order v-for="record in recordList" :record="record" :key="record.id" />
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import Order from "@/components/invite/history/Order"
import BottomBar from "@/components/public/footer"
import Empty from "@/components/public/Empty"
import Switcher from "@/components/public/Switcher"
import { Swiper, SwiperSlide } from "vue-awesome-swiper"
import "swiper/css/swiper.min.css"

export default {
  name: "InviteHistory",
  components: { Swiper, SwiperSlide, BottomBar, Empty, Order, Switcher },
  data() {
    return {
      tab: 0,
      friendCount: undefined,
      recordCount: undefined,
      friendList: undefined,
      recordList: [],
    }
  },
  watch: {
    tab: function (index) {
      if (this.swiper.activeIndex !== index) {
        this.swiper.slideTo(index, 300)
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    swiper() {
      return this.$refs.mySwiper.$swiper
    },
    tabItems() {
      return [this.user.identity > 1 ? "好友" : "客户", "购课记录"]
    }
  },
  created() {
    this.getInviteFriends()
    this.getInviteRecord()
  },
  methods: {
    async getInviteRecord() {
      const res = await this.$api.user.GET_INVITE_RECORD()
      this.recordList = res
    },
    async getInviteFriends() {
      const res = await this.$api.user.GET_INVITE_FRIENDS()
      this.friendList = res
    },
    toTab(index) {
      this.swiper.slideTo(index, 300)
    },
  },
}
</script>

<style lang="scss" scoped>
// @import "../../../static/css/public.scss";

#inviteRecord {
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;
  $primary: $red;

  #footer-wrapper {
    z-index: 999;
  }
  #close {
    position: fixed;
    z-index: 1000;
    margin: 0;
    top: 21px;
    padding: 0;
    left: 5%;
  }

  .navbar {
    position: fixed;
    top: 0;
    z-index: 999;
    width: 100%;
    background: white;
    padding: 10px 5%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    .link {
      font-size: 0.8rem;
      @include avenir-demi();
      color: $red;
      transition: all 0.1s;
      &:active {
        opacity: 0.6;
      }
    }
  }
  .swiper {
    width: 100%;
    .swiper-slide {
      overflow: scroll;
      margin-top: 56px;
      padding: 15px 0 15px 5%;
      height: calc(100vh - 107px);
      .empty {
        padding-right: 5%;
      }
    }
  }
  h2 {
    font-size: 1.25rem;
    font-weight: bold;
    padding: 0;
  }
  .item {
    display: flex;
    padding: 15px 0;
    border-bottom: 1px solid #eee;
    align-items: center;
    .avatar {
      width: 45px;
      height: 45px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 8px;
    }
    .content {
      height: 100%;
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: center;
      h3 {
        font-size: 1rem;
        margin: 0;
        font-weight: 400;
        @include avenir-demi();
      }
      p {
        font-size: 0.9rem;
        line-height: 1;
        margin-top: 5px;
        opacity: 0.7;
      }
      > div {
        display: flex;
        align-items: center;
        margin-top: 5px;
      }
      .button {
        @include avenir();
        padding: 3px 8px;
        font-size: 0.8rem;
        background: $red;
        color: #fff;
        border-radius: 3px;
        font-weight: 500;
        &.wait {
          background-color: #efefef;
          color: $grey;
        }
      }
      .cashout {
        padding: 3px 8px;
        margin: 0;
        font-weight: 500;
        font-size: 0.8rem;
        i {
          margin-right: 3px;
        }
      }
      .grey {
        color: $black;
        opacity: 0.5;
      }
      .red {
        color: $red;
      }
    }
    > .price {
      padding-right: 5%;
      font-size: 1rem;
      font-weight: 500;
      color: $primary;
      @include avenir();
    }
  }
}
</style>
